import HCLDX from "@system/config/hcldx";
import Helper from "../../src/support/Helper";

class Forecast {
    static FORECAST_DATA = Helper.getForecastUrl() + '/api/forecast/forecast/list';
    static FORECAST_SHARE = Helper.getForecastUrl() + '/api/forecast/forecast/sendemail';
    static FORECAST_COUNT = Helper.getForecastUrl() + '/api/forecast/forecast/count';
    static FORECAST_DOWNLOAD = Helper.getForecastUrl() + '/api/forecast/forecast/download';
    static getForecastRouteURL() {
        return HCLDX.baseURL() + '/resources/my-avnet/forecast';
    }
}

export default Forecast;